module.exports = __webpack_public_path__ + "static/media/caja-registradora.0edcc9f6.png";